/* eslint-disable max-len */
import moment from "moment";

import { isDateExpired } from 'Core/helpers/date';

export const STATUSES = {
  pending: "pending",
  active: "active",
  stopped: "stopped",
  failed: "failed",
};

export const getExpiredDate = (startedAt) => {
  const date = new Date(startedAt);
  date.setMonth(date.getMonth() + 1);

  return moment(date).format("D MMMM YYYY");
};

// Подписаться
export const isNew = status => status === STATUSES.pending;
// Продлить подписку
export const isExpired = (startedAt) => {
  const date = new Date(startedAt);
  date.setMonth(date.getMonth() + 1);

  return isDateExpired(moment(date).startOf("day"));
};
// Возобновить подписку
export const isResumable = (startedAt, status) => !isExpired(startedAt) && status === STATUSES.stopped;
// Отменить подписку
export const isActive = (startedAt, status) => !isExpired(startedAt) && status === STATUSES.active;
export const getStateTitle = (startedAt, status) => {
  if (isNew(status)) {
    return "Не подключена";
  }

  if (isExpired(startedAt)) {
    return "Закончилась";
  }

  if (isResumable(startedAt, status)) {
    return "Приостановлено";
  }

  return "Активно";
};
